import { useQuery } from '@tanstack/react-query';
import { getApiKeys } from './api-keys.service';

export function useApiKeys(organizationId: string | null, userId: string | null) {
  return useQuery({
    queryKey: ['api-keys', organizationId, userId],
    queryFn: () => getApiKeys(organizationId ?? ''),
    enabled: !!organizationId,
    retry: false,
    staleTime: 0,
    gcTime: 0,
  });
}
